export const DefaultInitialLedgerEntryValues = {
  documentId: null,
  glCode: "",
  includeIfZero: false,
  invoiceCategory: null,
  taxType: "",
  tagIds: [],
};
